import { useTaskFiltersStore } from '@/entities/task/model/stores/task-filters';
import { useTasks } from '@/features/tasks/model/useTaskActions';
import { useAuthStore } from '@/store/auth';
import { format, isSameDay, parseISO } from 'date-fns';
import { useMemo, useState } from 'react';
import { MeetingSlotForm } from './MeetingSlotForm';
import { SlotsPanel } from './SlotsPanel';
import { useMeetingSlotForm } from '../model/useMeetingSlotForm';

const DATE_FORMAT = 'yyyy-MM-dd';

export const CreateMeetingFromSlot = () => {
  const { selectedDate } = useTaskFiltersStore();
  const { userId } = useAuthStore();

  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);
  const [selectedDuration, setSelectedDuration] = useState<30 | 60>(60);

  const date = format(selectedDate, DATE_FORMAT);
  const { data, isFetching } = useTasks(
    {
      page: 1,
      perPage: 200,
      dateFrom: date,
      dateTo: date,
      currentUserId: userId,
    },
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(userId),
      staleTime: 2 * 60 * 1000,
    }
  );

  const dayTasks = useMemo(
    () =>
      (data?.items ?? []).filter(
        (task) =>
          task.dueDate && isSameDay(parseISO(task.dueDate), selectedDate)
      ),
    [data?.items, selectedDate]
  );

  const handleSelectSlot = (slot: string, duration: 30 | 60) => {
    setSelectedSlot(slot);
    setSelectedDuration(duration);
  };

  const handleCloseForm = () => {
    setSelectedSlot(null);
  };

  const handleTimeFieldClick = () => {
    setSelectedSlot(null);
  };

  const form = useMeetingSlotForm({
    selectedDate,
    selectedDuration,
    selectedSlot: selectedSlot ?? '',
    onClose: handleCloseForm,
  });

  return (
    <>
      {!selectedSlot ? (
        <SlotsPanel
          selectedDate={selectedDate}
          tasks={dayTasks}
          onSelectSlot={handleSelectSlot}
          selectedSlot={selectedSlot}
          isLoading={isFetching}
        />
      ) : (
        <MeetingSlotForm
          form={form}
          selectedSlot={selectedSlot}
          onTimeClick={handleTimeFieldClick}
        />
      )}
    </>
  );
};
